/**
 * A place to handle things for the groups box
 */
namespace appn.userGroupFilter {
    export let selectedGroupId: string | null = appn.emptyString;

    export function init(reloadUrl: string, onAfterGroupChanged?: Function): void {
        const groupIdFromUrl = utils.getUrlParamByName('groupId');
        let value = getStateOrDefault().value;
        if (groupIdFromUrl)
            value = groupIdFromUrl;

        // Auto select the initial default filter
        setValue(value);

        addEvents(reloadUrl);
    }

    function addEvents(reloadUrl: string) {
        $('.appnUserGroupFilter .appnUserGroupFilter-link').off().on('click', function(e) {
            e.preventDefault();
            setValue($(this).prop('id'));
        });

        // Listen for close modal
        $(document).on('hidden.bs.modal', function() {
            if (!iframe.getHost().reloadFlag)
                return;

            appn.location.navTo(reloadUrl);
        });
    }

    /**
     * Will get the date filters value from local storage or direct from UI is not in LS.
     */
    export function getStateOrDefault(): INameValuePair {
        const appnUserGroupFilter = $('.appnUserGroupFilter');
        return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnUserGroupFilter), getValue());
    }

    export function getValue(): string {
        const appnUserGroupFilter = $('.appnUserGroupFilter');
        const value = appnUserGroupFilter.find('li.active .appnUserGroupFilter-link').prop('id');
        if (value === 'appnUserGroupFilter-all')
            return appn.emptyString;

        return value;
    }

    export function setValue(value?: string) {
        appn.dataTable.uncheckAllRowsBox();
        selectedGroupId = !value || value === 'appnUserGroupFilter-all' ? appn.emptyString : value;

        if (getValue() === value)
            return; // No need to set if already the same

        // Set the active class
        const appnUserGroupFilter = $('.appnUserGroupFilter');
        appnUserGroupFilter.find('li').removeClass('active');
        appnUserGroupFilter.find('#' + (!value ? 'appnUserGroupFilter-all' : value)).closest('li').addClass('active');
    }

    export function reset() {
        setValue();
    }

    export function listContains(value: string) {
        let exists = false;
        const templates = $('.appnUserGroupFilter .appnUserGroupFilter-link');
        $(templates).each((function(this: any): boolean {
            if ((this).id === 'appnUserGroupFilter-all')
                return true;

            if ((this).id === value) {
                exists = true;
                return false;
            }

            return true;
        } as any));

        return exists;
    }
}
